import { Button, ButtonProps } from 'antd';
import { useCallback } from 'react';
import { useTranslate } from '@tolgee/react';
import { useSlateStatic } from 'slate-react';
import LyEditor from '../utils/LyEditor';

const DividingLineButton = (props: ButtonProps) => {
  const { t } = useTranslate();

  const editor = useSlateStatic();

  const handleInsertDividingLine = useCallback(() => {
    LyEditor.insertDividingLine(editor);
  }, [editor]);

  return (
    <Button
      size="small"
      type="link"
      onMouseDown={(e) => e.preventDefault()}
      onClick={handleInsertDividingLine}
      {...props}
    >
      {t('marketing.插入新消息分割')}
    </Button>
  );
};

export default DividingLineButton;
